/* ==========================================================================
   App Docs Hub — Search + Filter
   ========================================================================== */
(function () {
  const hub = document.querySelector('.app-docs-hub');
  if (!hub) return;

  const input = hub.querySelector('[data-docs-search]');
  const clearBtn = hub.querySelector('[data-docs-search-clear]');
  const filters = hub.querySelectorAll('[data-docs-filter]');
  const cards = hub.querySelectorAll('[data-doc-card]');
  const grid = hub.querySelector('[data-docs-grid]');
  const empty = hub.querySelector('[data-docs-empty]');

  let activeCategory = 'all';

  function applyFilters() {
    const query = (input ? input.value : '').toLowerCase().trim();
    let visible = 0;

    cards.forEach(function (card) {
      const cat = card.getAttribute('data-doc-category') || '';
      const title = card.getAttribute('data-doc-title') || '';
      const desc = card.getAttribute('data-doc-desc') || '';
      const tags = card.getAttribute('data-doc-tags') || '';

      var matchCat = activeCategory === 'all' || cat === activeCategory;
      var matchSearch = !query ||
        title.indexOf(query) !== -1 ||
        desc.indexOf(query) !== -1 ||
        tags.indexOf(query) !== -1;

      if (matchCat && matchSearch) {
        card.hidden = false;
        visible++;
      } else {
        card.hidden = true;
      }
    });

    if (empty) {
      empty.hidden = visible > 0;
    }

    if (clearBtn) {
      clearBtn.hidden = !query;
    }
  }

  // Search
  if (input) {
    input.addEventListener('input', applyFilters);
  }

  // Clear
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (input) {
        input.value = '';
        input.focus();
      }
      applyFilters();
    });
  }

  // Category filters
  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeCategory = btn.getAttribute('data-docs-filter');
      filters.forEach(function (f) {
        f.classList.toggle('app-docs-hub__filter--active', f === btn);
      });
      applyFilters();
    });
  });

  // Copy code buttons (for detail pages loaded alongside)
  document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var codeBlock = btn.closest('.agency-faq-detail-content__code-block');
      if (!codeBlock) return;
      var code = codeBlock.querySelector('code');
      if (!code) return;

      navigator.clipboard.writeText(code.textContent).then(function () {
        var label = btn.querySelector('span');
        if (label) {
          label.textContent = 'Copied!';
          setTimeout(function () {
            label.textContent = 'Copy';
          }, 2000);
        }
      });
    });
  });

  // TOC active state tracking
  var tocLinks = document.querySelectorAll('.agency-faq-detail-content__toc-link');
  if (tocLinks.length > 0) {
    var headings = [];
    tocLinks.forEach(function (link) {
      var id = link.getAttribute('href');
      if (id) {
        var el = document.querySelector(id);
        if (el) headings.push({ el: el, link: link });
      }
    });

    if (headings.length > 0) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
            var match = headings.find(function (h) { return h.el === entry.target; });
            if (match) match.link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-80px 0px -60% 0px', threshold: 0 });

      headings.forEach(function (h) { observer.observe(h.el); });
    }
  }
})();
